function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"])
    return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r))
    return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
import { z } from 'zod';
export function fileToBase64(file) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            return resolve(reader.result);
        };
        reader.onerror = reject;
    });
}
export var isAdminPolicy = function isAdminPolicy() {
    var _sessionStorage$getIt;
    var policy = JSON.parse((_sessionStorage$getIt = sessionStorage.getItem('policy')) !== null && _sessionStorage$getIt !== void 0 ? _sessionStorage$getIt : '[]');
    if (policy.length === 0)
        return false;
    return policy.some(function (item) {
        return item.name === 'Admin';
    });
};
var httpUrlSchema = z.string().url().refine(function (url) {
    try {
        var urlObj = new URL(url);
        return urlObj.protocol === 'http:' || urlObj.protocol === 'https:';
    }
    catch (_unused) {
        return false;
    }
}, {
    message: 'URL must use HTTP or HTTPS protocol'
});
export var isValidHttpUrl = function isValidHttpUrl(url) {
    return httpUrlSchema.safeParse(url).success;
};
export var isAuthorized = function isAuthorized(action) {
    try {
        var _sessionStorage$getIt2;
        // Get policies from sessionStorage
        var policies = JSON.parse((_sessionStorage$getIt2 = sessionStorage.getItem('policy')) !== null && _sessionStorage$getIt2 !== void 0 ? _sessionStorage$getIt2 : '[]');
        if (policies.length === 0) {
            return false;
        }
        // Separate allowed and denied actions
        var allowedActions = new Set();
        var deniedActions = new Set();
        // Process each policy
        policies.forEach(function (policy) {
            try {
                var _policy$effect;
                // Extract actions from resource_action array (complex API structure)
                var actions = [];
                if (policy.resource_action && Array.isArray(policy.resource_action)) {
                    // resource_action contains objects with action arrays
                    policy.resource_action.forEach(function (resourceAction) {
                        if (resourceAction.action && Array.isArray(resourceAction.action)) {
                            actions.push.apply(actions, _toConsumableArray(resourceAction.action));
                        }
                    });
                }
                // Add actions to appropriate set based on effect
                // Handle both lowercase and uppercase effect values
                var effect = (_policy$effect = policy.effect) === null || _policy$effect === void 0 ? void 0 : _policy$effect.toLowerCase();
                if (effect === 'allow') {
                    actions.forEach(function (act) {
                        return allowedActions.add(act);
                    });
                }
                else if (effect === 'deny') {
                    actions.forEach(function (act) {
                        return deniedActions.add(act);
                    });
                }
            }
            catch (error) {
                console.warn('Failed to process policy:', error);
            }
        });
        // Check authorization: action must be explicitly allowed and not denied
        return allowedActions.has(action) && !deniedActions.has(action);
    }
    catch (error) {
        console.error('Error in isAuthorized function:', error);
        return false;
    }
};
